import { useState } from "react";
import { _sendContactForm } from "../data/site";

function ContactForm() {

    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = async () => {
        _sendContactForm(email, message).then(() => {
            setIsSubmitted(true);
            setEmail('');
            setMessage('');
        }).catch(() => {
            alert("Something went wrong and your contact form could not be submitted"); 
        });
};
if (isSubmitted) {
    return (
        <div className="container">
            <div className="box has-text-centered">
                <h2 className="title is-4">Thank you!</h2>
                <p>Your message has been sent.</p>
            </div>
        </div>
    );
}

return (
    <div className="container">
        <div className="box">
            <h1 className="title is-3 has-text-centered mb-5">
                Contact Us
            </h1>

            <form>
                <div className="field">
                    <div className="control">
                        <label className="checkbox" htmlFor="includeEmail">
                            <input
                                type="checkbox"
                                id="includeEmail"
                                checked={!!email}
                                onChange={(e) => setEmail(e.target.checked)}
                                className="mr-2"
                            />
                            Include My Email Address
                        </label>
                    </div>
                    <p className="help">
                        You only need to include your email address if you would like a response to your message.
                    </p>
                </div>

                <div className="field">
                    <label htmlFor="message" className="label">
                        Your Message (1000 characters limit)
                    </label>
                    <div className="control">
                        <textarea
                            id="message"
                            rows="6"
                            maxLength={1000}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="textarea"
                            placeholder="Type your message here..."
                            required
                        ></textarea>
                    </div>
                </div>

                <div className="field">
                    <div className="control">
                        <button
                            type="button"
                            className="button is-primary is-fullwidth"
                            onClick={handleSubmit}>
                            Send Message
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
);
}

export default ContactForm;